import { Computer, Email } from "@mui/icons-material";
import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";

const MobileWarning: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "background.default",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <img
              src="/aa_logo_highres_white_900.png"
              alt="Alpha Affinity Logo"
              style={{
                height: "200px",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Desktop Icon */}
          <Computer
            sx={{
              fontSize: 80,
              color: "primary.main",
              mb: 2,
            }}
          />

          {/* Main Heading */}
          <Typography
            component="h1"
            variant="h4"
            gutterBottom
            sx={{ fontWeight: 600 }}
          >
            Desktop Required
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ mb: 3, lineHeight: 1.7 }}
          >
            This application requires a desktop browser for optimal performance
            and functionality.
          </Typography>

          {/* Requirements Box */}
          <Box
            sx={{
              backgroundColor: "background.default",
              borderRadius: 2,
              padding: 3,
              mb: 3,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Please access from:
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: "left", mb: 1 }}
            >
              • Desktop computer
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: "left", mb: 1 }}
            >
              • Laptop computer
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: "left", mb: 2 }}
            >
              • Minimum screen width: 768px
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ display: "block", mt: 2, fontStyle: "italic" }}
            >
              The complex data visualizations, interactive maps, and graph
              networks are designed for larger screens.
            </Typography>
          </Box>

          {/* Support Contact */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mt: 3,
            }}
          >
            <Email sx={{ fontSize: 20, color: "primary.main" }} />
            <Typography variant="body2" color="textSecondary">
              Need help?{" "}
              <a
                href="mailto:support@alpha-affinity.com"
                style={{
                  color: "#1976d2",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                support@alpha-affinity.com
              </a>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default MobileWarning;
